<template>
    <v-btn icon v-on="$listeners" v-bind="attrs" elevation="0">
        <v-icon v-text="icon" v-bind="attrsIcon"></v-icon>
    </v-btn>
</template>

<script>
export default {
    inheritAttrs: false,
    props: {
        icon: {
            type: String,
            required: true,
        },
        size: {
            type: String,
            required: false,
            validator: (value) =>
                ["small", "x-small", "normal", "large", "x-large"].includes(value),
        },
    },
    computed: {
        attrs() {
            const { elevation, ...attrs } = this.$attrs
            return { ...this.propsSize, ...attrs };
        },
        attrsIcon() {
            return this.propsSize;
        },
        propsSize() {
            return this.size && this.size !== "normal" ? { [this.size]: true } : {};
        },
    },
};
</script>
